import { Reveal } from "./Reveal";

export default function WarumLive() {
  return (
    <section data-testid="warum-live-section" className="bg-shell px-6 md:px-14 py-20 md:py-28">
      <div className="max-w-3xl mx-auto">
        <Reveal>
          <p className="text-xs md:text-sm font-medium uppercase tracking-[0.32em] text-bronze mb-6">
            Mehr als eine Meditation zum Anhören
          </p>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="font-serif tracking-tight text-2xl md:text-4xl leading-tight text-espresso max-w-2xl">
            Dieser Abend ist eine Verabredung mit dir selbst.
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="mt-10 text-base md:text-lg font-light leading-relaxed text-taupe">
            Eine Aufnahme kannst du irgendwann starten. Morgen. Nächste Woche. Wenn
            du Zeit hast. Und manchmal wird aus «irgendwann» einfach nie.
          </p>
          <p className="mt-5 text-base md:text-lg font-light leading-relaxed text-taupe">
            Am Donnerstag entscheidest du dich ganz bewusst: Diese 60 Minuten gehören
            mir.
          </p>
          <p className="mt-5 text-base md:text-lg font-light leading-relaxed text-taupe">
            Ich bin live bei dir und begleite dich vom Ankommen über die
            Hypnomeditation bis zum ruhigen Zurückkommen.
          </p>
          <p className="mt-5 text-base md:text-lg font-light leading-relaxed text-taupe">
            Du musst nichts vorbereiten. Du musst nichts können. Du musst nichts
            erreichen.
          </p>
        </Reveal>
        <Reveal delay={0.24}>
          <div data-testid="warum-live-highlight" className="mt-12 border-l-2 border-gold pl-6 md:pl-8">
            <p className="font-serif italic text-xl md:text-2xl leading-snug text-espresso tracking-tight">
              Du darfst dich einfach zurücklehnen und führen lassen.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
